import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React from 'react';

import DataMapper from '../components/DataMapper';
import EventViewer from '../components/EventViewer';

const hasAnEventMappingConfiguration = mapping =>
	typeof Object.values(mapping).find(
		val => typeof val.event !== 'undefined'
	) !== 'undefined';

export class WidgetContainer extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			eventViewer:
				typeof window === 'undefined' ||
				window.localStorage.getItem('eventViewer') === null
					? false
					: window.localStorage.getItem('eventViewer') === 'true',
			eventViewerData: [],
			eventViewerCount: 0
		};
	}

	componentDidMount() {
		window.DDC = window.DDC || {};
		window.DDC.WidgetData = window.DDC.WidgetData || {};
		window.DDC.WidgetData['ws-tagging'] =
			window.DDC.WidgetData['ws-tagging'] || {};
		window.DDC.WidgetData['ws-tagging'].mapping = this.props.mapping;
		if (window && window.DDC && window.DDC.pubsub) {
			window.DDC.pubsub.publish('ws-tagging-ready');
		}

		window.addEventListener('eventViewerData', ({ detail = {} }) =>
			this.setState(({ eventViewerData, eventViewerCount }) => {
				eventViewerData.unshift({
					detail,
					eventViewerCount: eventViewerCount + 1
				});
				return {
					eventViewerData,
					eventViewerCount: eventViewerCount + 1
				};
			})
		);

		window.addEventListener(
			'keydown',
			({ altKey, ctrlKey, metaKey, shiftKey, key }) => {
				if (altKey && ctrlKey && metaKey && shiftKey && key === 'Î') {
					this.setState(({ eventViewer }) => ({
						eventViewer: !eventViewer
					}));
					window.localStorage.setItem(
						'eventViewer',
						this.state.eventViewer
					);
				}
			}
		);
	}

	render() {
		return (
			<React.Fragment>
				{hasAnEventMappingConfiguration(this.props.mapping) && (
					<DataMapper
						appIsMounted={null}
						mapping={this.props.mapping}
					/>
				)}
				{this.state.eventViewer && (
					<EventViewer
						count={this.state.eventViewerCount}
						data={this.state.eventViewerData}
					/>
				)}
			</React.Fragment>
		);
	}
}

WidgetContainer.propTypes = {
	mapping: PropTypes.objectOf(PropTypes.object)
};

const mapStateToProps = state => {
	return {
		mapping: state.mapping
	};
};

const mapDispatchToProps = _dispatch => ({});

const Widget = connect(mapStateToProps, mapDispatchToProps)(WidgetContainer);

export default Widget;
